<h5 mat-dialog-title>Timeout Warning!</h5>
<mat-dialog-content>
    <span>{{ timeoutMessage }}</span>
</mat-dialog-content>
<mat-progress-bar
    mode="determinate"
    [value]="100 - (countdown / maxCount) * 100"
></mat-progress-bar>
<mat-dialog-actions>
    <button
        mat-button
        color="primary"
        *ngIf="countdown > 0"
        (click)="onStayClick()"
    >
        Stay Logged In
    </button>
    <button mat-button color="warn" (click)="onLogoutClick()">Log Out</button>
</mat-dialog-actions>
